/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST_DELETE_USER, REQUEST_EMAIL_VERIFICATION } from './Constant';
import { deleteUserRequestError, deleteUserRequestSuccess, emailVerificationRequestError, emailVerificationRequestSuccess } from './Actions';
import { Modal } from 'antd';

function* deleteUser(action) {

    try {            

        console.log('action', action);
        
        
        const deleteUserDetails = action.payload;
        const orgId = 1;
        

        const url = `${process.env.REACT_APP_API_BASE_URL}/delete-account`;
  
        // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        const data = {
            organisationsId: orgId,
            firstName: deleteUserDetails?.firstName,
            lastName: deleteUserDetails?.lastName,
            emailAddress: deleteUserDetails?.email,
            phoneNumber: deleteUserDetails?.phoneNumber,
            message: deleteUserDetails?.feedback,
            userType: 1
        };        

        const response = yield call(axios.post, url, data, { headers});

        // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            // Dispatch the success action with data and message      
            yield put(deleteUserRequestSuccess(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(deleteUserRequestError('An error occurred.'));
        }

    } catch (error) {
        yield put(deleteUserRequestError('An error occurred.'));
    // throw error;
    // yield put(fetchUserFailure(error));
    }

}


function* verifiUser(action) {

    try {            
        
        const verificationDetails = action.payload;
        

        const url = `${process.env.REACT_APP_API_BASE_URL}/confirm-delete-account`;
  
        // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        const data = {
            id : parseInt(verificationDetails.emailVerificationId),
            code : parseInt(verificationDetails.verification)
        };        

        const response = yield call(axios.post, url, data, { headers});

        console.log('response.status', response.status);
        
        // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            // Dispatch the success action with data and message      
            Modal.success({
                title: 'Your account deletion request has been sent successfully.'
            });
            yield put(emailVerificationRequestSuccess(response.data));
        } else {
            Modal.warning({
                title : 'Invalid verification code'
            });
            // Dispatch the failure action with the response message
            yield put(emailVerificationRequestError('An error occurred.'));
        }

    } catch (error) {
        yield put(emailVerificationRequestError('An error occurred.'));
    // throw error;
    // yield put(fetchUserFailure(error));
    }

}

// Watcher Saga
export function* watchFetchDeleteAccount() {
    yield takeEvery(REQUEST_DELETE_USER, deleteUser);
    yield takeEvery(REQUEST_EMAIL_VERIFICATION, verifiUser);


}
